module.exports = __webpack_public_path__ + "img/terroir-grid-2.66e172f1.jpg";